export default "__VITE_ASSET__CpCLZWQ$__"